/**
 * 数字枚举值
 *
 * 包含从0到9999的数字常量，以及常用的大数上限值
 */
export enum EnumNumberValue {
  /**
   * 数字-1
   */
  minusOne = -1,
  /**
   *  数字0
   */
  zero = 0,
  /**
   * 数字1
   */
  one = 1,
  /**
   * 数字2
   */
  two = 2,
  /**
   * 数字3
   */
  three = 3,
  /**
   * 数字4
   */
  four = 4,
  /**
   * 数字5
   */
  five = 5,
  /**
   * 数字6
   */
  six = 6,
  /**
   * 数字7
   */
  seven = 7,
  /**
   * 数字8
   */
  eight = 8,
  /**
   * 数字9
   */
  nine = 9,
  /**
   * 数字10
   */
  ten = 10,
  /**
   * 数字11
   */
  eleven = 11,
  /**
   * 数字12
   */
  twelve = 12,
  /**
   * 数字13
   */
  thirteen = 13,
  /**
   * 数字14
   */
  fourteen = 14,
  /**
   * 数字15
   */
  fifteen = 15,
  /**
   * 数字16
   */
  sixteen = 16,
  /**
   * 数字17
   */
  seventeen = 17,
  /**
   * 数字18
   */
  eighteen = 18,
  /**
   * 数字19
   */
  nineteen = 19,
  /**
   * 20
   */
  twenty = 20,
  /**
   * 21
   */
  twentyOne = 21,
  /**
   * 22
   */
  twentyTwo = 22,
  /**
   * 23
   */
  twentyThree = 23,
  /**
   * 24
   */
  twentyFour = 24,
  /**
   * 25
   */
  twentyFive = 25,
  /**
   * 26
   */
  twentySix = 26,
  /**
   * 27
   */
  twentySeven = 27,
  /**
   * 28
   */
  twentyEight = 28,
  /**
   * 29
   */
  twentyNine = 29,
  /**
   * 30
   */
  thirty = 30,
  /**
   * 31
   */
  thirtyOne = 31,
  /**
   * 32
   */
  thirtyTwo = 32,
  /**
   * 33
   */
  thirtyThree = 33,
  /**
   * 34
   */
  thirtyFour = 34,
  /**
   * 35
   */
  thirtyFive = 35,
  /**
   * 36
   */
  thirtySix = 36,
  /**
   * 37
   */
  thirtySeven = 37,
  /**
   * 38
   */
  thirtyEight = 38,
  /**
   * 39
   */
  thirtyNine = 39,
  /**
   * 40
   */
  forty = 40,
  /**
   * 41
   */
  fortyOne = 41,
  /**
   * 42
   */
  fortyTwo = 42,
  /**
   * 43
   */
  fortyThree = 43,
  /**
   * 44
   */
  fortyFour = 44,
  /**
   * 45
   */
  fortyFive = 45,
  /**
   * 46
   */
  fortySix = 46,
  /**
   * 47
   */
  fortySeven = 47,
  /**
   * 48
   */
  fortyEight = 48,
  /**
   * 49
   */
  fortyNine = 49,
  /**
   * 50
   */
  fifty = 50,
  /**
   * 51
   */
  fiftyOne = 51,
  /**
   * 52
   */
  fiftyTwo = 52,
  /**
   * 53
   */
  fiftyThree = 53,
  /**
   * 54
   */
  fiftyFour = 54,
  /**
   * 55
   */
  fiftyFive = 55,
  /**
   * 56
   */
  fiftySix = 56,
  /**
   * 57
   */
  fiftySeven = 57,
  /**
   * 58
   */
  fiftyEight = 58,
  /**
   * 59
   */
  fiftyNine = 59,
  /**
   * 60
   */
  sixty = 60,
  /**
   * 61
   */
  sixtyOne = 61,
  /**
   * 62
   */
  sixtyTwo = 62,
  /**
   * 63
   */
  sixtyThree = 63,
  /**
   * 64
   */
  sixtyFour = 64,
  /**
   * 65
   */
  sixtyFive = 65,
  /**
   * 66
   */
  sixtySix = 66,
  /**
   * 67
   */
  sixtySeven = 67,
  /**
   *  68
   */
  sixtyEight = 68,
  /**
   * 69
   */
  sixtyNine = 69,
  /**
   * 70
   */
  seventy = 70,
  /**
   * 71
   */
  seventyOne = 71,
  /**
   * 72
   */
  seventyTwo = 72,
  /**
   * 73
   */
  seventyThree = 73,
  /**
   * 74
   */
  seventyFour = 74,
  /**
   * 75
   */
  seventyFive = 75,
  /**
   * 76
   */
  seventySix = 76,
  /**
   * 77
   */
  seventySeven = 77,
  /**
   * 78
   */
  seventyEight = 78,
  /**
   * 79
   */
  seventyNine = 79,
  /**
   * 80
   */
  eighty = 80,
  /**
   * 81
   */
  eightyOne = 81,
  /**
   * 82
   */
  eightyTwo = 82,
  /**
   * 83
   */
  eightyThree = 83,
  /**
   * 84
   */
  eightyFour = 84,
  /**
   * 85
   */
  eightyFive = 85,
  /**
   * 86
   */
  eightySix = 86,
  /**
   * 87
   */
  eightySeven = 87,
  /**
   * 88
   */
  eightyEight = 88,
  /**
   * 89
   */
  eightyNine = 89,
  /**
   * 90
   */
  ninety = 90,
  /**
   * 91
   */
  ninetyOne = 91,
  /**
   * 92
   */
  ninetyTwo = 92,
  /**
   * 93
   */
  ninetyThree = 93,
  /**
   * 94
   */
  ninetyFour = 94,
  /**
   * 95
   */
  ninetyFive = 95,
  /**
   * 96
   */
  ninetySix = 96,
  /**
   * 97
   */
  ninetySeven = 97,
  /**
   * 98
   */
  ninetyEight = 98,
  /**
   * 99
   */
  ninetyNine = 99,
  /**
   *  数字100
   *
   */
  oneHundred = 100,
  /**
   *  数字110
   *
   */
  oneHundredTen = 110,
  /**
   *  数字120
   *
   */
  oneHundredTwenty = 120,
  /**
   *  数字130
   *
   */
  oneHundredThirty = 130,
  /**
   *  数字140
   *
   */
  oneHundredForty = 140,
  /**
   *  数字150
   *
   */
  oneHundredFifty = 150,
  /**
   *  数字160
   *
   */
  oneHundredSixty = 160,
  /**
   *  数字170
   *
   */
  oneHundredSeventy = 170,
  /**
   *  数字180
   *
   */
  oneHundredEighty = 180,
  /**
   *  数字190
   *
   */
  oneHundredNinety = 190,
  /**
   *  数字200
   *
   */
  twoHundred = 200,
  /**
   * 数字250
   */
  twoHundredFifty = 250,
  /**
   * 数字280
   */
  twoHundredEighty = 280,
  /**
   *  数字300
   *
   */
  threeHundred = 300,
  /**
   *  数字400
   *
   */
  fourHundred = 400,
  /**
   *  数字500
   */
  fiveHundred = 500,
  /**
   *  数字600
   */
  sixHundred = 600,
  /**
   *  数字700
   */
  sevenHundred = 700,
  /**
   * 数字800
   */
  eightHundred = 800,
  /**
   *  数字900
   */
  nineHundred = 900,
  /**
   * 数字999
   */
  nineHundredNinetyNine = 999,
  /**
   * 数字1000
   */
  oneThousand = 1000,
  /**
   * 数字1200
   */
  oneThousandTwoHundred = 1200,
  /**
   * 数字1300
   */
  oneThousandThreeHundred = 1300,
  /**
   * 数字1500
   */
  oneThousandFiveHundred = 1500,
  /**
   * 数字2000
   */
  twoThousand = 2000,
  /**
   * 数字3000
   */
  threeThousand = 3000,
  /**
   * 数字4000
   */
  fourThousand = 4000,
  /**
   * 数字5000
   */
  fiveThousand = 5000,
  /**
   * 数字6000
   */
  sixThousand = 6000,
  /**
   * 数字7000
   */
  sevenThousand = 7000,
  /**
   *  数字8000
   */
  eightThousand = 8000,
  /**
   *  数字9000
   */
  nineThousand = 9000,
  /**
   * 四位数最大值9999
   */
  MAX_4_DIGITS = 9999,
  /**
   * 数字10000
   */
  tenThousand = 10000,
  /**
   * 五位数最大值99999
   */
  MAX_5_DIGITS = 99999,
  /**
   * 六位数最大值99999
   */
  MAX_6_DIGITS = 999999,
  /**
   * 七位数最大值99999
   */
  MAX_7_DIGITS = 9999999,
  /**
   * 八位数最大值99999
   */
  MAX_8_DIGITS = 99999999,
  /**
   * 九位数最大值99999
   */
  MAX_9_DIGITS = 999999999,
  /**
   * 十位数最大值99999
   */
  MAX_10_DIGITS = 9999999999,
  /**
   * 十一位数最大值99999
   */
  MAX_11_DIGITS = 99999999999,
  /**
   * 十二位数最大值99999
   */
  MAX_12_DIGITS = 999999999999,
  /**
   * 十三位数最大值99999
   */
  MAX_13_DIGITS = 9999999999999,
  /**
   * 十四位数最大值99999
   */
  MAX_14_DIGITS = 99999999999999,
  /**
   * 手机号最小值13000000000
   */
  MIN_PHONE_NUMBER_DIGIT = 13000000000,
  /**
   * 手机号最大值19999999999
   */
  MAX_PHONE_NUMBER_DIGIT = 19999999999,
}
